// extracted by mini-css-extract-plugin
module.exports = {"AboutCompany":"_3DFftMME","AboutItems":"_9HvgsfIu","AboutItem":"_1H-hN47Y","AboutIcon":"_3cQ_a0E5","AboutContent":"_1JJdTIVB"};
    if(module.hot) {
      // 1754515033639
      var cssReload = require("!../../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  